/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'

const SettingsLazyRouteImport = createFileRoute('/settings')()
const ManageLazyRouteImport = createFileRoute('/manage')()
const HistoryLazyRouteImport = createFileRoute('/history')()
const IndexLazyRouteImport = createFileRoute('/')()
const VideoSlugIdLazyRouteImport = createFileRoute('/video/$slug/$id')()
const PlaylistSlugPlaylistIdVideoIdLazyRouteImport = createFileRoute(
  '/playlist/$slug/$playlistId/$videoId',
)()

const SettingsLazyRoute = SettingsLazyRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/settings.lazy').then((d) => d.Route))
const ManageLazyRoute = ManageLazyRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/manage.lazy').then((d) => d.Route))
const HistoryLazyRoute = HistoryLazyRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/history.lazy').then((d) => d.Route))
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const VideoSlugIdLazyRoute = VideoSlugIdLazyRouteImport.update({
  id: '/video/$slug/$id',
  path: '/video/$slug/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/video.$slug.$id.lazy').then((d) => d.Route),
)
const PlaylistSlugPlaylistIdVideoIdLazyRoute =
  PlaylistSlugPlaylistIdVideoIdLazyRouteImport.update({
    id: '/playlist/$slug/$playlistId/$videoId',
    path: '/playlist/$slug/$playlistId/$videoId',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/playlist.$slug.$playlistId.$videoId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/history': typeof HistoryLazyRoute
  '/manage': typeof ManageLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/video/$slug/$id': typeof VideoSlugIdLazyRoute
  '/playlist/$slug/$playlistId/$videoId': typeof PlaylistSlugPlaylistIdVideoIdLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/history': typeof HistoryLazyRoute
  '/manage': typeof ManageLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/video/$slug/$id': typeof VideoSlugIdLazyRoute
  '/playlist/$slug/$playlistId/$videoId': typeof PlaylistSlugPlaylistIdVideoIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/history': typeof HistoryLazyRoute
  '/manage': typeof ManageLazyRoute
  '/settings': typeof SettingsLazyRoute
  '/video/$slug/$id': typeof VideoSlugIdLazyRoute
  '/playlist/$slug/$playlistId/$videoId': typeof PlaylistSlugPlaylistIdVideoIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/history'
    | '/manage'
    | '/settings'
    | '/video/$slug/$id'
    | '/playlist/$slug/$playlistId/$videoId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/history'
    | '/manage'
    | '/settings'
    | '/video/$slug/$id'
    | '/playlist/$slug/$playlistId/$videoId'
  id:
    | '__root__'
    | '/'
    | '/history'
    | '/manage'
    | '/settings'
    | '/video/$slug/$id'
    | '/playlist/$slug/$playlistId/$videoId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  HistoryLazyRoute: typeof HistoryLazyRoute
  ManageLazyRoute: typeof ManageLazyRoute
  SettingsLazyRoute: typeof SettingsLazyRoute
  VideoSlugIdLazyRoute: typeof VideoSlugIdLazyRoute
  PlaylistSlugPlaylistIdVideoIdLazyRoute: typeof PlaylistSlugPlaylistIdVideoIdLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage': {
      id: '/manage'
      path: '/manage'
      fullPath: '/manage'
      preLoaderRoute: typeof ManageLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video/$slug/$id': {
      id: '/video/$slug/$id'
      path: '/video/$slug/$id'
      fullPath: '/video/$slug/$id'
      preLoaderRoute: typeof VideoSlugIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playlist/$slug/$playlistId/$videoId': {
      id: '/playlist/$slug/$playlistId/$videoId'
      path: '/playlist/$slug/$playlistId/$videoId'
      fullPath: '/playlist/$slug/$playlistId/$videoId'
      preLoaderRoute: typeof PlaylistSlugPlaylistIdVideoIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  HistoryLazyRoute: HistoryLazyRoute,
  ManageLazyRoute: ManageLazyRoute,
  SettingsLazyRoute: SettingsLazyRoute,
  VideoSlugIdLazyRoute: VideoSlugIdLazyRoute,
  PlaylistSlugPlaylistIdVideoIdLazyRoute:
    PlaylistSlugPlaylistIdVideoIdLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
